import React, { useEffect, useState } from 'react';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';

import PersonAddRoundedIcon from '@mui/icons-material/PersonAddRounded';

import ClientTable from '../components/ClientTable';
import clientApi from './../api/client';
import { useNavigate } from 'react-router-dom';
import Breadcrumb from '../components/Breadcrumb';
import { useToast } from '../helper/ToastProvider';

export default function Clients() {
  const { showToast } = useToast();
  const navigate = useNavigate();
  const [clients, setClients] = useState();

  useEffect(() => {
    _getAllClients();
  }, []);

  const _getAllClients = async () => {
    try {
      const { data } = await clientApi.getAllClients();
      setClients(data);
    } catch (e) {
      showToast({
        message: 'Client Fetch Failed',
        severity: 'danger',
      });
    }
  };

  return (
    <>
      <Breadcrumb crumb={['Clients']} />
      <Box
        sx={{
          display: 'flex',
          mb: 1,
          gap: 1,
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'start', sm: 'center' },
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <Typography level='h2' component='h1'>
          Clients
        </Typography>
        <Button color='primary' onClick={() => navigate('create')} startDecorator={<PersonAddRoundedIcon />} size='sm'>
          Create New
        </Button>
      </Box>
      {clients && (
        <>
          <ClientTable
            clients={clients}
            onEdit={(clientId) => navigate(`create?client=${clientId}`)}
            onDelete={async (clientId) => {
              try {
                await clientApi.deleteClient(clientId);
                await _getAllClients();
                showToast({
                  message: 'Client Delete Success',
                  severity: 'success',
                });
              } catch (e) {
                showToast({
                  message: 'Client Delete Failed',
                  severity: 'danger',
                });
              }
            }}
          />
          {/* <OrderList /> */}
        </>
      )}
    </>
  );
}
